import { mediaItems } from '@/mocks/home';

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-black text-foreground-950 font-heading">
            精彩花絮
          </h2>
          <p className="text-sm md:text-base text-foreground-500 mt-2">
            热门剧集名场面与幕后花絮精选
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 md:gap-6">
          {mediaItems.map((item) => (
            <a
              key={item.id}
              href="#hero"
              className="group relative bg-background-50 rounded-xl overflow-hidden cursor-pointer no-underline block hover:shadow-lg transition-shadow"
            >
              <div className="relative aspect-video overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-black/20 group-hover:bg-black/30 transition-colors"></div>
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-14 h-14 md:w-16 md:h-16 rounded-full bg-primary-500/90 flex items-center justify-center group-hover:bg-primary-500 transition-colors">
                    <i className="ri-play-fill text-background-50 text-2xl md:text-3xl ml-1"></i>
                  </div>
                </div>
                <div className="absolute top-3 right-3">
                  <span className="px-2 py-1 rounded-md bg-black/60 text-white text-xs font-medium">
                    {item.duration}
                  </span>
                </div>
                <div className="absolute bottom-3 left-3">
                  <span className="px-2 py-1 rounded-full bg-primary-500 text-background-50 text-xs font-semibold">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-base md:text-lg font-bold text-foreground-900 font-heading mb-1">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed mb-2">
                  {item.description}
                </p>
                <div className="flex items-center gap-1 text-xs text-foreground-400">
                  <i className="ri-eye-line"></i>
                  <span>{item.views} 次观看</span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}